import { useState, useRef, useEffect } from "react";

const LOGO = "/logo.webp"; // Loaded from public folder — much faster

// ── EMAILJS CONFIG ────────────────────────────────────────────────────────────
const EMAILJS_SERVICE_ID  = "service_y9wnx8m";
const EMAILJS_TEMPLATE_ID = "template_r4sitqp";
const EMAILJS_PUBLIC_KEY  = "9B_1A2eoOGIHTah35";

// Engineer email addresses
const ENGINEER_EMAILS = {
  e1: "mrr800wdy@gmail.com",
  e2: "tharunan987@gmail.com",
  e3: "rajragul89@gmail.com",
  e4: "rojan@casbuildingservices.co.uk",
};

async function sendJobEmail(job, eng) {
  // Load EmailJS if not already loaded
  if (!window.emailjs) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    window.emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
  }
  const params = {
    engineer_name: eng.name,
    job_id:        job.id,
    date:          new Date(job.date).toLocaleDateString("en-GB", {day:"numeric", month:"long", year:"numeric"}),
    customer_name: job.customerName,
    address:       job.address,
    phone:         job.phone,
    job_type:      job.jobType,
    description:   job.description || "No additional details provided.",
    to_email:      ENGINEER_EMAILS[eng.id] || `${eng.name.toLowerCase().replace(" ",".")}@casbuildingservices.co.uk`,
    from_name:     "CASBS Office",
    reply_to:      "casbuildingservices@gmail.com",
  };
  return window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, params);
}



// ── SUPABASE DATABASE CONFIG ──────────────────────────────────────────────────
const SUPABASE_URL  = "https://ijswbgtvelssnleqlpkb.supabase.co";
const SUPABASE_KEY  = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlqc3diZ3R2ZWxzc25sZXFscGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4NDQ1OTIsImV4cCI6MjA5MzQyMDU5Mn0.vLOc5OmWXLDXRoBHwaHzzyrPyYqNW0MjusbXEHbx4_U";
const SB_HEADERS    = { "Content-Type": "application/json", "apikey": SUPABASE_KEY, "Authorization": `Bearer ${SUPABASE_KEY}`, "Prefer": "return=representation" };
const SB_URL        = `${SUPABASE_URL}/rest/v1/jobs`;

// Database helper functions
async function dbLoadJobs() {
  const res = await fetch(`${SB_URL}?order=created_at.desc`, { headers: SB_HEADERS });
  if (!res.ok) throw new Error("Failed to load jobs");
  const rows = await res.json();
  return rows.map(r => ({
    id:           r.id,
    engineerId:   r.engineer_id,
    date:         r.date,
    customerName: r.customer_name,
    address:      r.address,
    phone:        r.phone,
    jobType:      r.job_type,
    description:  r.description,
    status:       r.status,
    notification: r.notification,
    createdAt:    r.created_at,
    completion:   r.completion,
  }));
}

async function dbSaveJob(job) {
  const row = {
    id:           job.id,
    engineer_id:  job.engineerId,
    date:         job.date,
    customer_name:job.customerName,
    address:      job.address,
    phone:        job.phone,
    job_type:     job.jobType,
    description:  job.description,
    status:       job.status,
    notification: job.notification,
    created_at:   job.createdAt,
    completion:   job.completion,
  };
  const res = await fetch(SB_URL, {
    method: "POST",
    headers: SB_HEADERS,
    body: JSON.stringify(row),
  });
  if (!res.ok) throw new Error("Failed to save job");
  return res.json();
}

async function dbUpdateJob(job) {
  const row = {
    status:     job.status,
    completion: job.completion,
  };
  const res = await fetch(`${SB_URL}?id=eq.${job.id}`, {
    method: "PATCH",
    headers: SB_HEADERS,
    body: JSON.stringify(row),
  });
  if (!res.ok) throw new Error("Failed to update job");
  return res.json();
}

const USERS = [
  { id:"coord1", name:"CASBS Office", role:"coordinator", pin:"1234", avatar:"CO", color:"#1a6fc4" },
  { id:"e1", name:"R Janaraj",  role:"engineer", type:"Gas",         pin:"2001", avatar:"RJ", color:"#4a9c2f" },
  { id:"e2", name:"P Tharunan", role:"engineer", type:"Gas",         pin:"2002", avatar:"PT", color:"#e8191b" },
  { id:"e3", name:"R Ragulan",  role:"engineer", type:"Electrical",  pin:"3001", avatar:"RR", color:"#1a6fc4" },
  { id:"e4", name:"Rojan",      role:"engineer", type:"Electrical",  pin:"3002", avatar:"RO", color:"#b8a000" },
];

const ENGINEERS = USERS.filter(u => u.role === "engineer");

const JOB_TYPES = ["Boiler Service","Gas Safety Check","Boiler Repair","New Installation","Electrical Inspection","Fault Finding","Consumer Unit Upgrade","EV Charger Install","Emergency Call-out","Other"];

const STATUS = {
  assigned:      { label:"Assigned",         color:"#7a5800", bg:"#fef9c3" },
  "in-progress": { label:"In Progress",      color:"#1a6fc4", bg:"#dbeef8" },
  completed:     { label:"Completed",         color:"#2d6b1a", bg:"#d8f0c8" },
  "follow-up":   { label:"Follow-up Needed",  color:"#9e1010", bg:"#fde8e8" },
};

// Jobs loaded from Supabase database — no hardcoded seed data needed

const genId    = () => "JOB-" + String(Math.floor(Math.random()*9000)+1000);
const todayStr = () => new Date().toISOString().split("T")[0];
const fmtDate  = d  => new Date(d).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"});
const fmtTime  = iso=> new Date(iso).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"});

/* PDF */
function exportPDF(job) {
  const eng=USERS.find(u=>u.id===job.engineerId);
  const c=job.completion;
  const sub=(c?(parseFloat(c.labour||0)+parseFloat(c.materialsCost||0)):0).toFixed(2);
  const vat=(parseFloat(sub)*.2).toFixed(2);
  const grand=(parseFloat(sub)*1.2).toFixed(2);
  const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Invoice ${job.id}</title>
  <style>body{font-family:Georgia,serif;max-width:720px;margin:40px auto;color:#1a1a1a;padding:0 24px}
  .hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #1a6fc4;padding-bottom:20px;margin-bottom:28px}
  img.logo{height:80px} .inv{text-align:right} .inv h2{font-size:30px;color:#1a6fc4;margin:0} .inv p{margin:3px 0;font-size:13px;color:#555}
  h3{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#999;border-bottom:1px solid #eee;padding-bottom:4px;margin:20px 0 10px}
  .grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:6px}
  .field label{font-size:11px;color:#999;display:block;margin-bottom:2px} .field p{margin:0;font-weight:600;font-size:14px}
  table{width:100%;border-collapse:collapse;margin-top:8px} th{background:#1a6fc4;color:#fff;padding:9px 14px;text-align:left;font-size:12px}
  td{padding:9px 14px;border-bottom:1px solid #eee;font-size:14px} .tot td{font-weight:700;background:#f0f4ff}
  .grand td{font-weight:800;font-size:16px;background:#1a6fc4;color:#fff}
  .badge{display:inline-block;padding:4px 12px;border-radius:20px;font-size:12px;font-weight:700;background:${STATUS[job.status]?.bg};color:${STATUS[job.status]?.color}}
  .footer{margin-top:36px;text-align:center;font-size:12px;color:#aaa;border-top:1px solid #eee;padding-top:16px}
  .photos{display:flex;gap:10px;flex-wrap:wrap;margin-top:10px} .photos img{width:120px;height:90px;object-fit:cover;border-radius:6px;border:1px solid #ddd}
  @media print{button{display:none}}</style>
  </head><body>
  <div class="hdr"><img class="logo" src="${LOGO}" alt="CAS Building Services"/>
  <div class="inv"><h2>INVOICE</h2><p><strong>${job.id}</strong></p><p>Date: ${fmtDate(job.createdAt)}</p>${c?`<p>Completed: ${fmtDate(c.submittedAt)}</p>`:""}
  <p style="margin-top:8px"><span class="badge">${STATUS[job.status]?.label}</span></p></div></div>
  <h3>Customer</h3><div class="grid">
  <div class="field"><label>Name</label><p>${job.customerName}</p></div>
  <div class="field"><label>Phone</label><p>${job.phone}</p></div>
  <div class="field"><label>Address</label><p>${job.address}</p></div>
  <div class="field"><label>Engineer</label><p>${eng?.name} (${eng?.type})</p></div></div>
  <h3>Job</h3><div class="grid">
  <div class="field"><label>Type</label><p>${job.jobType}</p></div>
  <div class="field"><label>Date</label><p>${fmtDate(job.date)}</p></div></div>
  <div class="field" style="margin-top:10px"><label>Description</label><p style="font-weight:400;line-height:1.5">${job.description}</p></div>
  ${c?`<h3>Work Done</h3><div class="grid"><div class="field"><label>Time</label><p>${c.timeSpent} hours</p></div><div class="field"><label>Materials</label><p>${c.materials||"None"}</p></div></div>
  ${c.notes?`<div class="field" style="margin-top:10px"><label>Notes</label><p style="font-weight:400;line-height:1.5">${c.notes}</p></div>`:""}
  <h3>Charges</h3><table><tr><th>Description</th><th style="text-align:right">Amount</th></tr>
  <tr><td>Labour (${c.timeSpent} hrs)</td><td style="text-align:right">£${parseFloat(c.labour).toFixed(2)}</td></tr>
  ${parseFloat(c.materialsCost)>0?`<tr><td>Materials</td><td style="text-align:right">£${parseFloat(c.materialsCost).toFixed(2)}</td></tr>`:""}
  <tr class="tot"><td>Subtotal</td><td style="text-align:right">£${sub}</td></tr>
  <tr class="tot"><td>VAT 20%</td><td style="text-align:right">£${vat}</td></tr>
  <tr class="grand"><td>TOTAL DUE</td><td style="text-align:right">£${grand}</td></tr></table>
  ${c.photos&&c.photos.length>0?`<h3>Photos</h3><div class="photos">${c.photos.map(p=>`<img src="${p.data}"/>`).join("")}</div>`:""}`:""}
  <div class="footer"><p>Thank you for choosing CAS Building Services Ltd</p><p>Gas Safe Registered · NICEIC Approved · Payment due 30 days</p></div>
  <br/><button onclick="window.print()" style="padding:10px 24px;background:#1a6fc4;color:#fff;border:none;border-radius:8px;font-size:15px;cursor:pointer;display:block;margin:20px auto">🖨 Print / Save as PDF</button>
  </body></html>`;
  const blob=new Blob([html],{type:"text/html"});
  const url=URL.createObjectURL(blob);
  const a=document.createElement("a");
  a.href=url; a.target="_blank"; a.rel="noopener noreferrer";
  document.body.appendChild(a); a.click();
  document.body.removeChild(a);
  setTimeout(()=>URL.revokeObjectURL(url),5000);
}

/* NOTIF BANNER */
function NotifBanner({notifs,dismiss}) {
  if (!notifs.length) return null;
  return (
    <div style={{position:"fixed",top:72,right:18,zIndex:300,display:"flex",flexDirection:"column",gap:8,maxWidth:340}}>
      {notifs.map(n=>(
        <div key={n.id} style={{background:n.type==="email"?"#eff6ff":"#f2fbee",border:`1px solid ${n.type==="email"?"#93c5fd":"#a8d890"}`,borderRadius:12,padding:"12px 14px",display:"flex",gap:10,alignItems:"flex-start",boxShadow:"0 4px 12px rgba(0,0,0,.1)"}}>
          <span style={{fontSize:18}}>{n.type==="email"?"📧":"📱"}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:12,fontWeight:700,color:n.type==="email"?"#1d4ed8":"#4a9c2f",marginBottom:2}}>{n.type==="email"?"Email Sent":"SMS Sent"} · {n.to}</div>
            <div style={{fontSize:12,color:"#444"}}>{n.message}</div>
          </div>
          <button onClick={()=>dismiss(n.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#aaa",fontSize:16}}>×</button>
        </div>
      ))}
    </div>
  );
}

/* LOGIN */
function Login({onLogin}) {
  const [sel,setSel]=useState(null);
  const [pin,setPin]=useState("");
  const [err,setErr]=useState("");
  const [shake,setShake]=useState(false);
  const press=d=>{
    if(pin.length>=4)return;
    const next=pin+d;
    setPin(next);
    if(next.length===4){
      setTimeout(()=>{
        if(sel.pin===next){onLogin(sel);}
        else{setShake(true);setErr("Wrong PIN — try again");setPin("");setTimeout(()=>setShake(false),500);}
      },200);
    }
  };
  return (
    <div style={{minHeight:"100vh",background:"#fffff0",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"'DM Sans',sans-serif"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-8px)}75%{transform:translateX(8px)}}
        .ucard{background:#fff;border:2px solid #e2dcc8;border-radius:14px;padding:14px 18px;cursor:pointer;display:flex;align-items:center;gap:12px;transition:all .18s;box-shadow:0 2px 6px rgba(0,0,0,.06)}
        .ucard:hover{border-color:#1a6fc4;background:#f0f6ff;transform:translateX(3px)}
        .npad{width:68px;height:68px;border-radius:50%;background:#fff;border:1.5px solid #ddd;font-size:22px;font-weight:600;font-family:inherit;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .12s;color:#222;box-shadow:0 2px 5px rgba(0,0,0,.07)}
        .npad:hover{background:#e8f0fe;border-color:#1a6fc4;transform:scale(1.06)}
        .npad:active{transform:scale(.94)}
        .dot{width:13px;height:13px;border-radius:50%;border:2px solid #ccc;transition:all .15s}
      `}</style>
      <div style={{animation:"fadeUp .4s ease",textAlign:"center",marginBottom:32}}>
        <img src={LOGO} alt="CAS Building Services" style={{width:200,height:"auto",display:"block",margin:"0 auto 10px"}}/>
        <p style={{color:"#888",fontSize:13,fontWeight:500}}>Job Management Portal</p>
      </div>
      {!sel?(
        <div style={{width:"100%",maxWidth:400,animation:"fadeUp .35s ease .08s both"}}>
          <p style={{textAlign:"center",fontSize:12,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#aaa",marginBottom:14}}>Select your profile</p>
          <div style={{display:"flex",flexDirection:"column",gap:9}}>
            {USERS.map(u=>(
              <div key={u.id} className="ucard" onClick={()=>{setSel(u);setPin("");setErr("");}}>
                <div style={{width:42,height:42,borderRadius:11,background:`linear-gradient(135deg,${u.color}99,${u.color})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:13,color:"#fff",flexShrink:0}}>{u.avatar}</div>
                <div>
                  <div style={{fontWeight:600,fontSize:14,color:"#1a1a1a"}}>{u.name}</div>
                  <div style={{fontSize:12,color:"#888"}}>{u.role==="coordinator"?"Office Coordinator":`${u.type} Engineer`}</div>
                </div>
                <span style={{marginLeft:"auto",color:"#bbb",fontSize:18}}>›</span>
              </div>
            ))}
          </div>
        </div>
      ):(
        <div style={{width:"100%",maxWidth:300,textAlign:"center",animation:"fadeUp .3s ease"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,justifyContent:"center",marginBottom:26}}>
            <div style={{width:46,height:46,borderRadius:13,background:`linear-gradient(135deg,${sel.color}99,${sel.color})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:14,color:"#fff"}}>{sel.avatar}</div>
            <div style={{textAlign:"left"}}>
              <div style={{fontWeight:700,color:"#1a1a1a",fontSize:15}}>{sel.name}</div>
              <div style={{fontSize:12,color:"#888"}}>{sel.role==="coordinator"?"Coordinator":`${sel.type} Engineer`}</div>
            </div>
          </div>
          <p style={{color:"#888",fontSize:13,marginBottom:18}}>Enter your 4-digit PIN</p>
          <div style={{display:"flex",gap:12,justifyContent:"center",marginBottom:26,animation:shake?"shake .4s ease":undefined}}>
            {[0,1,2,3].map(i=><div key={i} className="dot" style={{background:i<pin.length?"#1a6fc4":"transparent"}}/>)}
          </div>
          {err&&<p style={{color:"#e8191b",fontSize:13,marginBottom:14}}>{err}</p>}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,68px)",gap:12,justifyContent:"center",marginBottom:14}}>
            {[1,2,3,4,5,6,7,8,9].map(d=><button key={d} className="npad" onClick={()=>press(String(d))}>{d}</button>)}
            <div/>
            <button className="npad" onClick={()=>press("0")}>0</button>
            <button className="npad" onClick={()=>setPin(p=>p.slice(0,-1))}>⌫</button>
          </div>
          <button onClick={()=>setSel(null)} style={{background:"none",border:"none",color:"#1a6fc4",cursor:"pointer",fontSize:13,fontFamily:"inherit",fontWeight:600}}>← Back</button>
          <p style={{color:"#bbb",fontSize:11,marginTop:16}}>PINs: Office 1234 · RJ 2001 · PT 2002 · RR 3001 · RO 3002</p>
        </div>
      )}
    </div>
  );
}

/* MAIN APP */
export default function App() {
  const [user,setUser]     = useState(null);
  const [jobs,setJobs]     = useState([]);
  const [loading,setLoading] = useState(false);
  const [dbError,setDbError] = useState(null);
  const [modal,setModal]   = useState(null);
  const [selJob,setSelJob] = useState(null);
  const [tab,setTab]       = useState("dashboard");
  const [notifs,setNotifs] = useState([]);
  const [toast,setToast]   = useState(null);

  const showToast=(msg,t="ok")=>{setToast({msg,t});setTimeout(()=>setToast(null),3500);};
  const open=(m,j=null)=>{setModal(m);setSelJob(j);};
  const close=()=>{setModal(null);setSelJob(null);};

  // Load all jobs from Supabase when user logs in
  useEffect(()=>{
    if(!user) return;
    setLoading(true);
    setDbError(null);
    dbLoadJobs()
      .then(data=>{ setJobs(data); setLoading(false); })
      .catch(err=>{ console.error(err); setDbError("Could not connect to database. Check your internet connection."); setLoading(false); });
  },[user]);

  const pushNotif=async(job,method)=>{
    if(method==="none")return;
    const eng=USERS.find(u=>u.id===job.engineerId);
    const n={id:Date.now(),type:method,to:ENGINEER_EMAILS[eng.id]||`${eng.name.toLowerCase().replace(" ",".")}@casbuildingservices.co.uk`,message:`${job.id}: ${job.jobType} — ${job.address.split(",")[0]}`};
    setNotifs(p=>[...p,n]);
    setTimeout(()=>setNotifs(p=>p.filter(x=>x.id!==n.id)),6000);
    if(method==="email"){
      try {
        await sendJobEmail(job, eng);
        showToast(`Email sent to ${eng.name}!`);
      } catch(err) {
        console.error("EmailJS error:", err);
        showToast("Job saved but email failed — check EmailJS settings","err");
      }
    }
  };

  if(!user) return <Login onLogin={setUser}/>;

  if(loading) return (
    <div style={{minHeight:"100vh",background:"#fffff0",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{fontSize:40,marginBottom:16}}>⏳</div>
      <div style={{fontWeight:600,fontSize:16,color:"#333"}}>Loading jobs from database…</div>
      <div style={{fontSize:13,color:"#888",marginTop:6}}>Please wait</div>
    </div>
  );

  if(dbError) return (
    <div style={{minHeight:"100vh",background:"#fffff0",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',sans-serif",padding:24}}>
      <div style={{fontSize:40,marginBottom:16}}>⚠️</div>
      <div style={{fontWeight:700,fontSize:16,color:"#e8191b",marginBottom:8}}>Database Connection Error</div>
      <div style={{fontSize:13,color:"#555",textAlign:"center",maxWidth:320,marginBottom:20}}>{dbError}</div>
      <button onClick={()=>{setDbError(null);setLoading(true);dbLoadJobs().then(d=>{setJobs(d);setLoading(false);}).catch(e=>{setDbError(e.message);setLoading(false);});}} style={{background:"#1a6fc4",color:"#fff",border:"none",borderRadius:8,padding:"11px 24px",fontWeight:600,cursor:"pointer",fontSize:14}}>Try Again</button>
    </div>
  );

  return (
    <div style={{fontFamily:"'DM Sans',sans-serif",minHeight:"100vh",background:"#fffff0",color:"#1a1a1a"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-track{background:#f5f2e4} ::-webkit-scrollbar-thumb{background:#c8c2a8;border-radius:2px}
        .btn{cursor:pointer;border:none;border-radius:8px;font-family:inherit;font-weight:600;font-size:13px;transition:all .15s}
        .btn:hover{filter:brightness(.93);transform:translateY(-1px)} .btn:active{transform:translateY(0)}
        .card{background:#fff;border:1px solid #e2dcc8;border-radius:14px;box-shadow:0 2px 6px rgba(26,111,196,.06)}
        .inp{background:#fafaf5;border:1px solid #ddd8c4;border-radius:8px;color:#1a1a1a;font-family:inherit;font-size:14px;padding:10px 14px;width:100%;outline:none;transition:border .2s}
        .inp:focus{border-color:#1a6fc4} .inp option{background:#fff}
        .badge{display:inline-flex;align-items:center;padding:4px 11px;border-radius:20px;font-size:12px;font-weight:700}
        .overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);backdrop-filter:blur(5px);z-index:100;display:flex;align-items:center;justify-content:center;padding:20px}
        .modal{background:#fff;border:1px solid #e5e2db;border-radius:18px;width:100%;max-width:580px;max-height:90vh;overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,.14)}
        .jrow{padding:13px 15px;border-radius:10px;border:1px solid #e5e2db;background:#f9f8f5;transition:all .18s;cursor:pointer}
        .jrow:hover{border-color:#1a6fc4;background:#eef4ff}
        label{font-size:13px;font-weight:500;color:#777;display:block;margin-bottom:5px}
        @keyframes up{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
        .ani{animation:up .28s ease}
        .toast{position:fixed;bottom:26px;right:26px;padding:13px 20px;border-radius:12px;font-weight:600;font-size:14px;z-index:400;animation:up .3s ease;display:flex;align-items:center;gap:8px;box-shadow:0 8px 24px rgba(0,0,0,.14)}
        .tbtn{padding:8px 16px;border-radius:8px;font-weight:600;font-size:13px;cursor:pointer;border:none;font-family:inherit;transition:all .18s}
      `}</style>

      {/* TOP BAR */}
      <div style={{background:"#ffffff",borderBottom:"2px solid #e2dcc8",boxShadow:"0 2px 8px rgba(0,0,0,.06)",padding:"0 24px"}}>
        <div style={{maxWidth:1100,margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"space-between",height:66}}>
          <img src={LOGO} alt="CAS Building Services" style={{height:50,width:"auto"}}/>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            {user.role==="coordinator"&&(
              <>
                <button className="tbtn" onClick={()=>setTab("dashboard")} style={{background:tab==="dashboard"?"#1a6fc4":"transparent",color:tab==="dashboard"?"#fff":"#666"}}>📋 Dashboard</button>
                <button className="tbtn" onClick={()=>setTab("history")}   style={{background:tab==="history"?"#1a6fc4":"transparent",color:tab==="history"?"#fff":"#666"}}>🗂 History</button>
              </>
            )}
            <div style={{display:"flex",alignItems:"center",gap:8,background:"#fffff0",border:"1px solid #e5e2db",borderRadius:10,padding:"6px 12px",marginLeft:4}}>
              <div style={{width:28,height:28,borderRadius:8,background:`linear-gradient(135deg,${user.color}99,${user.color})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:12,color:"#fff"}}>{user.avatar}</div>
              <span style={{fontSize:13,fontWeight:500,color:"#333"}}>{user.name}</span>
            </div>
            <button className="btn" onClick={()=>setUser(null)} style={{background:"#fffff0",color:"#666",padding:"7px 13px",border:"1px solid #e5e2db"}}>Sign out</button>
          </div>
        </div>
      </div>

      <NotifBanner notifs={notifs} dismiss={id=>setNotifs(p=>p.filter(n=>n.id!==id))}/>

      <div style={{maxWidth:1100,margin:"0 auto",padding:"28px 24px"}}>
        {user.role==="coordinator"
          ?(tab==="dashboard"?<Dashboard jobs={jobs} open={open}/>:<History jobs={jobs} open={open}/>)
          :<EngineerView user={user} jobs={jobs.filter(j=>j.engineerId===user.id)} open={open}/>
        }
      </div>

      {modal==="newJob"   &&<NewJobModal  onClose={close} onSave={async j=>{
        try {
          await dbSaveJob(j);
          setJobs(p=>[...p,j]);
          pushNotif(j,j.notification);
          close();
          showToast("Job dispatched & saved!");
        } catch(err) {
          console.error(err);
          showToast("Job saved locally but database error occurred","err");
          setJobs(p=>[...p,j]);
          close();
        }
      }}/>}
      {modal==="complete" &&selJob&&<CompleteModal job={selJob} onClose={close} onSave={async d=>{
        const updated={...selJob,status:d.status,completion:d};
        try {
          await dbUpdateJob(updated);
          setJobs(p=>p.map(j=>j.id===selJob.id?updated:j));
          close();
          showToast("Report saved!");
        } catch(err) {
          console.error(err);
          setJobs(p=>p.map(j=>j.id===selJob.id?updated:j));
          close();
          showToast("Saved locally — check internet","err");
        }
      }}/>}
      {modal==="detail"   &&selJob&&<DetailModal   job={selJob} onClose={close} onExport={()=>exportPDF(selJob)}/>}

      {toast&&<div className="toast" style={{background:toast.t==="ok"?"#4a9c2f":"#e8191b",color:"#fff"}}>{toast.t==="ok"?"✓":"✗"} {toast.msg}</div>}
    </div>
  );
}

/* DASHBOARD */
function Dashboard({jobs,open}) {
  const td=jobs.filter(j=>j.date===todayStr());
  const stats=[
    {l:"Today's Jobs",v:td.length,                                   i:"📋",c:"#1a6fc4"},
    {l:"Completed",   v:td.filter(j=>j.status==="completed").length, i:"✅",c:"#2d6b1a"},
    {l:"In Progress", v:td.filter(j=>j.status==="in-progress").length,i:"🔄",c:"#b8a000"},
    {l:"Follow-up",   v:td.filter(j=>j.status==="follow-up").length, i:"🔔",c:"#9e1010"},
  ];
  return (
    <div className="ani">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:24}}>
        <div>
          <h1 style={{fontSize:23,fontWeight:700,letterSpacing:"-.02em"}}>Good day, CASBS Office 👋</h1>
          <p style={{color:"#888",marginTop:4,fontSize:13}}>{fmtDate(new Date().toISOString())} · {td.length} jobs today</p>
        </div>
        <button className="btn" onClick={()=>open("newJob")} style={{background:"#1a6fc4",color:"#fff",padding:"11px 20px"}}>+ Assign Job</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:24}}>
        {stats.map(s=>(
          <div key={s.l} className="card" style={{padding:"16px 18px"}}>
            <div style={{fontSize:22,marginBottom:8}}>{s.i}</div>
            <div style={{fontSize:26,fontWeight:700,color:s.c}}>{s.v}</div>
            <div style={{fontSize:12,color:"#888",marginTop:2}}>{s.l}</div>
          </div>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        {ENGINEERS.map(eng=>{
          const ej=jobs.filter(j=>j.engineerId===eng.id&&j.date===todayStr());
          return (
            <div key={eng.id} className="card" style={{padding:18}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                <div style={{width:38,height:38,borderRadius:11,background:`linear-gradient(135deg,${eng.color}88,${eng.color})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:13,color:"#fff"}}>{eng.avatar}</div>
                <div><div style={{fontWeight:600,fontSize:14}}>{eng.name}</div><div style={{fontSize:11,color:"#888"}}>{eng.type} Engineer</div></div>
                <span style={{marginLeft:"auto",fontSize:12,color:"#aaa"}}>{ej.length} today</span>
              </div>
              {ej.length===0&&<p style={{color:"#aaa",fontSize:13,textAlign:"center",padding:"10px 0"}}>No jobs today</p>}
              {ej.map(job=>(
                <div key={job.id} className="jrow" style={{marginBottom:8}} onClick={()=>open("detail",job)}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                    <span style={{fontFamily:"'DM Mono',monospace",fontSize:11,color:"#1a6fc4"}}>{job.id}</span>
                    <span className="badge" style={{background:STATUS[job.status].bg,color:STATUS[job.status].color}}>{STATUS[job.status].label}</span>
                  </div>
                  <div style={{fontWeight:600,fontSize:13}}>{job.customerName}</div>
                  <div style={{fontSize:12,color:"#888"}}>{job.jobType}</div>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* HISTORY */
function History({jobs,open}) {
  const [q,setQ]=useState(""); const [fE,setFE]=useState("all");
  const [fS,setFS]=useState("all"); const [fT,setFT]=useState("all");
  const [fr,setFr]=useState(""); const [to,setTo]=useState("");
  const filtered=jobs.filter(j=>{
    const sq=q.toLowerCase();
    return(!sq||[j.customerName,j.address,j.id,j.jobType].some(x=>x.toLowerCase().includes(sq)))
      &&(fE==="all"||j.engineerId===fE)&&(fS==="all"||j.status===fS)&&(fT==="all"||j.jobType===fT)
      &&(!fr||j.date>=fr)&&(!to||j.date<=to);
  }).sort((a,b)=>b.date.localeCompare(a.date));
  const rev=filtered.filter(j=>j.completion).reduce((s,j)=>s+parseFloat(j.completion.labour||0)+parseFloat(j.completion.materialsCost||0),0);
  return (
    <div className="ani">
      <div style={{marginBottom:20}}>
        <h1 style={{fontSize:23,fontWeight:700,letterSpacing:"-.02em"}}>Job History 🗂</h1>
        <p style={{color:"#888",fontSize:13,marginTop:4}}>Search, filter and export all jobs</p>
      </div>
      <div className="card" style={{padding:16,marginBottom:14}}>
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 1fr",gap:10}}>
          <input className="inp" placeholder="🔍  Search name, address, job ID…" value={q} onChange={e=>setQ(e.target.value)}/>
          <select className="inp" value={fE} onChange={e=>setFE(e.target.value)}><option value="all">All Engineers</option>{ENGINEERS.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}</select>
          <select className="inp" value={fS} onChange={e=>setFS(e.target.value)}><option value="all">All Statuses</option>{Object.entries(STATUS).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}</select>
          <select className="inp" value={fT} onChange={e=>setFT(e.target.value)}><option value="all">All Types</option>{JOB_TYPES.map(t=><option key={t} value={t}>{t}</option>)}</select>
          <input className="inp" type="date" value={fr} onChange={e=>setFr(e.target.value)} title="From"/>
          <input className="inp" type="date" value={to} onChange={e=>setTo(e.target.value)} title="To"/>
        </div>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
        <span style={{fontSize:13,color:"#888"}}>{filtered.length} job{filtered.length!==1?"s":""}</span>
        <span style={{fontSize:13,fontWeight:700,color:"#2d6b1a"}}>Revenue (completed): £{rev.toFixed(2)}</span>
      </div>
      <div className="card" style={{padding:14}}>
        {filtered.length===0&&<p style={{textAlign:"center",padding:"28px 0",color:"#aaa"}}>No jobs match your filters</p>}
        {filtered.map(job=>{
          const eng=USERS.find(u=>u.id===job.engineerId);
          const total=job.completion?(parseFloat(job.completion.labour||0)+parseFloat(job.completion.materialsCost||0)).toFixed(2):null;
          return (
            <div key={job.id} className="jrow" onClick={()=>open("detail",job)} style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
              <span style={{fontFamily:"'DM Mono',monospace",fontSize:11,color:"#1a6fc4",minWidth:76}}>{job.id}</span>
              <div style={{width:30,height:30,borderRadius:8,background:`linear-gradient(135deg,${eng.color}88,${eng.color})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:11,color:"#fff",flexShrink:0}}>{eng.avatar}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:600,fontSize:13}}>{job.customerName}</div>
                <div style={{fontSize:12,color:"#888",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{job.address}</div>
              </div>
              <div style={{fontSize:12,color:"#888",minWidth:110}}>{job.jobType}</div>
              <div style={{fontSize:12,color:"#888",minWidth:80}}>{fmtDate(job.date)}</div>
              {total&&<div style={{fontWeight:700,color:"#2d6b1a",minWidth:64,textAlign:"right"}}>£{total}</div>}
              <span className="badge" style={{background:STATUS[job.status].bg,color:STATUS[job.status].color,flexShrink:0}}>{STATUS[job.status].label}</span>
              <button className="btn" onClick={e=>{e.stopPropagation();exportPDF(job);}} style={{background:"#fffff0",color:"#555",padding:"6px 11px",border:"1px solid #ddd"}}>🖨 PDF</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ENGINEER VIEW */
function EngineerView({user,jobs,open}) {
  const td=jobs.filter(j=>j.date===todayStr());
  const past=jobs.filter(j=>j.date!==todayStr());
  return (
    <div className="ani">
      <div style={{marginBottom:22}}>
        <h1 style={{fontSize:23,fontWeight:700,letterSpacing:"-.02em"}}>Hello, {user.name} 👷</h1>
        <p style={{color:"#888",marginTop:4,fontSize:13}}>{fmtDate(new Date().toISOString())} · {td.length} job{td.length!==1?"s":""} today</p>
      </div>
      <div style={{display:"flex",gap:10,marginBottom:20}}>
        {[{l:"Today",v:td.length},{l:"Completed",v:jobs.filter(j=>j.status==="completed").length},{l:"Follow-up",v:jobs.filter(j=>j.status==="follow-up").length}].map(s=>(
          <div key={s.l} className="card" style={{padding:"14px 18px",flex:1,textAlign:"center"}}>
            <div style={{fontSize:21,fontWeight:700}}>{s.v}</div>
            <div style={{fontSize:12,color:"#888",marginTop:2}}>{s.l}</div>
          </div>
        ))}
      </div>
      {td.length===0&&<div className="card" style={{padding:36,textAlign:"center"}}><div style={{fontSize:30,marginBottom:10}}>✅</div><div style={{fontWeight:600}}>No jobs today</div><p style={{color:"#888",fontSize:13,marginTop:4}}>Contact the office if this seems wrong.</p></div>}
      {td.map((job,i)=>(
        <div key={job.id} className="card ani" style={{padding:20,marginBottom:14,animationDelay:`${i*.06}s`}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
            <div>
              <span style={{fontFamily:"'DM Mono',monospace",fontSize:11,color:"#1a6fc4"}}>{job.id}</span>
              <h2 style={{fontSize:17,fontWeight:700,marginTop:2}}>{job.customerName}</h2>
            </div>
            <span className="badge" style={{background:STATUS[job.status].bg,color:STATUS[job.status].color}}>{STATUS[job.status].label}</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
            {[{i:"📍",l:"Address",v:job.address},{i:"📞",l:"Phone",v:job.phone},{i:"🔧",l:"Job Type",v:job.jobType},{i:"📝",l:"Description",v:job.description}].map(x=>(
              <div key={x.l} style={{background:"#fafaf5",border:"1px solid #e5e2db",borderRadius:9,padding:"11px 13px"}}>
                <div style={{fontSize:11,color:"#888",marginBottom:3}}>{x.i} {x.l}</div>
                <div style={{fontSize:13,fontWeight:500}}>{x.v}</div>
              </div>
            ))}
          </div>
          {job.completion&&(
            <div style={{background:"#f2fbee",border:"1px solid #bbf7d0",borderRadius:10,padding:13,marginBottom:12}}>
              <div style={{fontSize:12,color:"#4a9c2f",fontWeight:700,marginBottom:8}}>✅ Report submitted · {fmtTime(job.completion.submittedAt)}</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                {[{l:"Time",v:`${job.completion.timeSpent}h`},{l:"Labour",v:`£${job.completion.labour}`},{l:"Materials",v:`£${job.completion.materialsCost||"0"}`}].map(x=>(
                  <div key={x.l}><div style={{fontSize:11,color:"#888"}}>{x.l}</div><div style={{fontWeight:700,fontSize:13}}>{x.v}</div></div>
                ))}
              </div>
              {job.completion.notes&&<p style={{marginTop:8,fontSize:13,color:"#555"}}>📝 {job.completion.notes}</p>}
            </div>
          )}
          <div style={{display:"flex",gap:8}}>
            {!["completed","follow-up"].includes(job.status)&&<button className="btn" onClick={()=>open("complete",job)} style={{background:"#4a9c2f",color:"#fff",padding:"10px 18px",flex:1}}>✓ Submit Report</button>}
            <button className="btn" onClick={()=>exportPDF(job)} style={{background:"#fffff0",color:"#555",padding:"10px 16px",border:"1px solid #ddd"}}>🖨 PDF</button>
          </div>
        </div>
      ))}
      {past.length>0&&(
        <div style={{marginTop:24}}>
          <p style={{fontSize:11,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#bbb",marginBottom:10}}>Past Jobs</p>
          <div className="card" style={{padding:12}}>
            {past.map(job=>(
              <div key={job.id} className="jrow" onClick={()=>open("detail",job)} style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <span style={{fontFamily:"'DM Mono',monospace",fontSize:11,color:"#1a6fc4",minWidth:76}}>{job.id}</span>
                <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13}}>{job.customerName}</div><div style={{fontSize:12,color:"#888"}}>{job.jobType}</div></div>
                <span style={{fontSize:12,color:"#aaa"}}>{fmtDate(job.date)}</span>
                <span className="badge" style={{background:STATUS[job.status].bg,color:STATUS[job.status].color}}>{STATUS[job.status].label}</span>
                <button className="btn" onClick={e=>{e.stopPropagation();exportPDF(job);}} style={{background:"#fffff0",color:"#555",padding:"6px 10px",border:"1px solid #ddd"}}>🖨</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

/* NEW JOB MODAL */
function NewJobModal({onClose,onSave}) {
  const [f,setF]=useState({engineerId:ENGINEERS[0].id,date:todayStr(),customerName:"",address:"",phone:"",jobType:JOB_TYPES[0],description:"",notification:"email"});
  const s=(k,v)=>setF(p=>({...p,[k]:v}));
  const eng=USERS.find(u=>u.id===f.engineerId);
  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div style={{padding:"20px 22px",borderBottom:"1px solid #e5e2db",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <h2 style={{fontSize:17,fontWeight:700}}>Assign New Job</h2>
          <button className="btn" onClick={onClose} style={{background:"#fffff0",color:"#888",padding:"5px 11px",fontSize:17,border:"1px solid #ddd"}}>×</button>
        </div>
        <div style={{padding:"18px 22px 22px",display:"flex",flexDirection:"column",gap:13}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label>Assign To</label><select className="inp" value={f.engineerId} onChange={e=>s("engineerId",e.target.value)}>{ENGINEERS.map(e=><option key={e.id} value={e.id}>{e.name} ({e.type})</option>)}</select></div>
            <div><label>Date</label><input className="inp" type="date" value={f.date} onChange={e=>s("date",e.target.value)}/></div>
          </div>
          <div><label>Customer Name *</label><input className="inp" placeholder="e.g. Mr. John Smith" value={f.customerName} onChange={e=>s("customerName",e.target.value)}/></div>
          <div><label>Address *</label><input className="inp" placeholder="Full address incl. postcode" value={f.address} onChange={e=>s("address",e.target.value)}/></div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label>Phone *</label><input className="inp" placeholder="07xxx xxxxxx" value={f.phone} onChange={e=>s("phone",e.target.value)}/></div>
            <div><label>Job Type</label><select className="inp" value={f.jobType} onChange={e=>s("jobType",e.target.value)}>{JOB_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
          </div>
          <div><label>Description</label><textarea className="inp" rows={3} placeholder="Equipment details, access notes…" value={f.description} onChange={e=>s("description",e.target.value)} style={{resize:"vertical"}}/></div>
          <div>
            <label>Notify Engineer Via</label>
            <div style={{display:"flex",gap:8}}>
              {[{v:"email",i:"📧",l:"Email"},{v:"sms",i:"📱",l:"SMS"},{v:"none",i:"🔕",l:"None"}].map(o=>(
                <button key={o.v} className="btn" onClick={()=>s("notification",o.v)} style={{flex:1,padding:"9px",background:f.notification===o.v?"#1a6fc4":"#fafaf5",color:f.notification===o.v?"#fff":"#555",border:`1px solid ${f.notification===o.v?"#1a6fc4":"#ddd8c4"}`}}>{o.i} {o.l}</button>
              ))}
            </div>
            {f.notification!=="none"&&<p style={{fontSize:12,color:"#888",marginTop:5}}>{f.notification==="email"?`→ ${ENGINEER_EMAILS[f.engineerId] || eng?.name.toLowerCase().replace(" ",".")+"@casbuildingservices.co.uk"}`:"→ Engineer's registered mobile"}</p>}
          </div>
          <button className="btn" onClick={()=>{if(!f.customerName||!f.address||!f.phone)return alert("Fill in all required fields.");onSave({...f,id:genId(),status:"assigned",createdAt:new Date().toISOString(),completion:null});}} style={{background:"#1a6fc4",color:"#fff",padding:"13px",fontSize:14,marginTop:4}}>Dispatch Job →</button>
        </div>
      </div>
    </div>
  );
}

/* COMPLETE MODAL */
function CompleteModal({job,onClose,onSave}) {
  const [f,setF]=useState({timeSpent:"",labour:"",materialsCost:"",materials:"",notes:"",status:"completed",photos:[]});
  const [submitting,setSubmitting]=useState(false);
  const s=(k,v)=>setF(p=>({...p,[k]:v}));
  const galleryRef=useRef(null);
  const cameraRef=useRef(null);

  const readFiles=e=>Array.from(e.target.files).forEach(file=>{
    const img=new Image();
    const objectUrl=URL.createObjectURL(file);
    img.onload=()=>{
      const MAX=800;
      const canvas=document.createElement("canvas");
      let w=img.width, h=img.height;
      if(w>h){ if(w>MAX){h=Math.round(h*MAX/w);w=MAX;} }
      else { if(h>MAX){w=Math.round(w*MAX/h);h=MAX;} }
      canvas.width=w; canvas.height=h;
      const ctx=canvas.getContext("2d");
      ctx.drawImage(img,0,0,w,h);
      const compressed=canvas.toDataURL("image/jpeg",0.6);
      URL.revokeObjectURL(objectUrl);
      setF(p=>({...p,photos:[...p.photos,{name:file.name,data:compressed}]}));
    };
    img.src=objectUrl;
  });

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div style={{padding:"20px 22px",borderBottom:"1px solid #e5e2db",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div><h2 style={{fontSize:17,fontWeight:700}}>Submit Job Report</h2><p style={{fontSize:12,color:"#888",marginTop:2}}>{job.id} · {job.customerName}</p></div>
          <button className="btn" onClick={onClose} style={{background:"#fffff0",color:"#888",padding:"5px 11px",fontSize:17,border:"1px solid #ddd"}}>×</button>
        </div>
        <div style={{padding:"18px 22px 22px",display:"flex",flexDirection:"column",gap:13}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label>Time Spent (hrs) *</label><input className="inp" type="number" step="0.5" placeholder="e.g. 2.5" value={f.timeSpent} onChange={e=>s("timeSpent",e.target.value)}/></div>
            <div><label>Labour Charge (£) *</label><input className="inp" type="number" placeholder="e.g. 120" value={f.labour} onChange={e=>s("labour",e.target.value)}/></div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label>Materials Used</label><input className="inp" placeholder="e.g. Filter, pump seal" value={f.materials} onChange={e=>s("materials",e.target.value)}/></div>
            <div><label>Materials Cost (£)</label><input className="inp" type="number" placeholder="e.g. 45" value={f.materialsCost} onChange={e=>s("materialsCost",e.target.value)}/></div>
          </div>
          <div><label>Outcome</label>
            <select className="inp" value={f.status} onChange={e=>s("status",e.target.value)}>
              <option value="completed">✅ Completed — no further visits</option>
              <option value="follow-up">🔔 Further visit required</option>
            </select>
          </div>
          <div><label>Notes</label><textarea className="inp" rows={3} placeholder="Observations, recommendations…" value={f.notes} onChange={e=>s("notes",e.target.value)} style={{resize:"vertical"}}/></div>

          <div>
            <label>Photographic Evidence</label>

            {/* iOS Safari requires visible or properly triggered inputs — we use a styled label trick that works on both iOS and Android */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>

              {/* TAKE PHOTO — uses capture="environment" for rear camera */}
              <label htmlFor="camInput" style={{
                display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                padding:"14px 10px",background:"#eaf3ff",color:"#1a6fc4",
                border:"2px solid #bfdbfe",borderRadius:10,fontSize:14,
                fontWeight:600,cursor:"pointer",textAlign:"center"
              }}>
                📷 Take Photo
              </label>
              <input
                id="camInput"
                type="file"
                accept="image/*"
                capture="environment"
                onChange={readFiles}
                style={{position:"absolute",width:"1px",height:"1px",opacity:0,overflow:"hidden",zIndex:-1}}
              />

              {/* GALLERY — no capture attribute so iOS shows gallery picker */}
              <label htmlFor="galInput" style={{
                display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                padding:"14px 10px",background:"#fafaf5",color:"#555",
                border:"2px dashed #ddd",borderRadius:10,fontSize:14,
                fontWeight:600,cursor:"pointer",textAlign:"center"
              }}>
                🖼 Gallery
              </label>
              <input
                id="galInput"
                type="file"
                accept="image/*"
                multiple
                onChange={readFiles}
                style={{position:"absolute",width:"1px",height:"1px",opacity:0,overflow:"hidden",zIndex:-1}}
              />
            </div>

            {f.photos.length>0&&(
              <div>
                <p style={{fontSize:12,color:"#888",marginBottom:6}}>{f.photos.length} photo{f.photos.length!==1?"s":""} attached</p>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  {f.photos.map((p,i)=>(
                    <div key={i} style={{position:"relative"}}>
                      <img src={p.data} alt="" style={{width:72,height:72,objectFit:"cover",borderRadius:8,border:"2px solid #e5e2db"}}/>
                      <div
                        onClick={()=>setF(p2=>({...p2,photos:p2.photos.filter((_,ii)=>ii!==i)}))}
                        style={{position:"absolute",top:-5,right:-5,background:"#e8191b",borderRadius:"50%",width:18,height:18,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,cursor:"pointer",color:"#fff",fontWeight:700}}
                      >×</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <button
            className="btn"
            disabled={submitting}
            onClick={async()=>{
              if(!f.timeSpent||!f.labour)return alert("Fill in time and labour.");
              setSubmitting(true);
              await onSave({...f,submittedAt:new Date().toISOString()});
              setSubmitting(false);
            }}
            style={{background:submitting?"#6ee7b7":"#4a9c2f",color:"#fff",padding:"13px",fontSize:14,marginTop:4,opacity:submitting?0.8:1,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
          >
            {submitting ? (
              <>
                <span style={{display:"inline-block",width:16,height:16,border:"2px solid #fff",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .7s linear infinite"}}/>
                Saving to database…
              </>
            ) : "✓ Submit Report"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* DETAIL MODAL */
function DetailModal({job,onClose,onExport}) {
  const eng=USERS.find(u=>u.id===job.engineerId);
  const c=job.completion;
  const sub=c?(parseFloat(c.labour||0)+parseFloat(c.materialsCost||0)).toFixed(2):null;
  const vat=sub?(parseFloat(sub)*.2).toFixed(2):null;
  const grand=sub?(parseFloat(sub)*1.2).toFixed(2):null;
  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e=>e.stopPropagation()}>
        <div style={{padding:"20px 22px",borderBottom:"1px solid #e5e2db",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div><h2 style={{fontSize:17,fontWeight:700}}>Job Details</h2><span style={{fontFamily:"'DM Mono',monospace",fontSize:12,color:"#1a6fc4"}}>{job.id}</span></div>
          <div style={{display:"flex",gap:8}}>
            <button className="btn" onClick={onExport} style={{background:"#1a6fc4",color:"#fff",padding:"8px 14px"}}>🖨 Export PDF</button>
            <button className="btn" onClick={onClose} style={{background:"#fffff0",color:"#888",padding:"5px 11px",fontSize:17,border:"1px solid #ddd"}}>×</button>
          </div>
        </div>
        <div style={{padding:"16px 22px 22px",display:"flex",flexDirection:"column",gap:11}}>
          <span className="badge" style={{background:STATUS[job.status].bg,color:STATUS[job.status].color,alignSelf:"flex-start"}}>{STATUS[job.status].label}</span>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {[{l:"👤 Customer",v:job.customerName},{l:"📍 Address",v:job.address},{l:"📞 Phone",v:job.phone},{l:"🔧 Job Type",v:job.jobType},{l:"👷 Engineer",v:`${eng?.name} (${eng?.type})`},{l:"📅 Date",v:fmtDate(job.date)}].map(x=>(
              <div key={x.l} style={{background:"#fafaf5",border:"1px solid #e5e2db",borderRadius:9,padding:"11px 13px"}}>
                <div style={{fontSize:11,color:"#888",marginBottom:2}}>{x.l}</div>
                <div style={{fontSize:13,fontWeight:600}}>{x.v}</div>
              </div>
            ))}
          </div>
          {job.description&&<div style={{background:"#fafaf5",border:"1px solid #e5e2db",borderRadius:9,padding:"11px 13px"}}><div style={{fontSize:11,color:"#888",marginBottom:2}}>📝 Description</div><div style={{fontSize:13}}>{job.description}</div></div>}
          {c&&(
            <div style={{background:"#f2fbee",border:"1px solid #bbf7d0",borderRadius:12,padding:16}}>
              <div style={{fontSize:12,fontWeight:700,color:"#4a9c2f",marginBottom:12}}>✅ COMPLETION REPORT · {fmtTime(c.submittedAt)}</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                {[{l:"Time on Site",v:`${c.timeSpent} hours`},{l:"Materials",v:c.materials||"None"},{l:"Notes",v:c.notes||"—"}].map(x=><div key={x.l}><div style={{fontSize:11,color:"#888"}}>{x.l}</div><div style={{fontWeight:600,fontSize:13}}>{x.v}</div></div>)}
              </div>
              <div style={{borderTop:"1px solid #bbf7d0",paddingTop:12,display:"flex",flexDirection:"column",gap:5}}>
                {[{l:"Labour",v:`£${parseFloat(c.labour).toFixed(2)}`},{l:"Materials",v:`£${parseFloat(c.materialsCost||0).toFixed(2)}`},{l:"Subtotal",v:`£${sub}`},{l:"VAT (20%)",v:`£${vat}`}].map(r=>(
                  <div key={r.l} style={{display:"flex",justifyContent:"space-between",fontSize:13}}><span style={{color:"#888"}}>{r.l}</span><span style={{fontWeight:600}}>{r.v}</span></div>
                ))}
                <div style={{display:"flex",justifyContent:"space-between",fontSize:16,fontWeight:800,marginTop:6,paddingTop:8,borderTop:"1px solid #bbf7d0"}}>
                  <span style={{color:"#2d6b1a"}}>TOTAL (inc. VAT)</span><span style={{color:"#2d6b1a"}}>£{grand}</span>
                </div>
              </div>
              {c.photos?.length>0&&<div style={{marginTop:12}}><div style={{fontSize:11,color:"#888",marginBottom:6}}>📷 Photos ({c.photos.length})</div><div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{c.photos.map((p,i)=><img key={i} src={p.data} alt="" style={{width:65,height:65,objectFit:"cover",borderRadius:8,border:"1px solid #bbf7d0"}}/>)}</div></div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
